import { apiSlice } from "core/api"
import { makeCrudEndpoints } from "common/api/apiHelpers"
import { BingoGame } from "bingo/types/bingo-game.model"

const api = apiSlice.injectEndpoints({
  endpoints: makeCrudEndpoints<"BingoGame", BingoGame>("BingoGame", "bingo-games"),
})

export const {
  useGetBingoGameQuery,
  useListBingoGamesQuery,
  useAddBingoGameMutation,
  useRemoveBingoGameMutation,
  useUpdateBingoGameMutation,
} = api